import { render, staticRenderFns } from "./TodayUsePower.vue?vue&type=template&id=0bffb720&scoped=true&"
import script from "./TodayUsePower.vue?vue&type=script&lang=js&"
export * from "./TodayUsePower.vue?vue&type=script&lang=js&"
import style0 from "./TodayUsePower.vue?vue&type=style&index=0&id=0bffb720&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bffb720",
  null
  
)

export default component.exports